// import React from "react";

// import {
//   ChevronDown,
//   ChevronRight,
// } from "lucide-react";

// import ChecklistItemRow from "./ChecklistItemRow";

// const OnboardingPhaseAccordion = ({
//   phaseName,
//   phaseData,
//   isOpen,
//   onToggle,
//   clientId,
//   onChecklistUpdate,
// }) => {
//   const allItems = Object.values(
//     phaseData.sections,
//   ).flat();

//   const completedItems =
//     allItems.filter(
//       (item) => item.received,
//     ).length;

//   const percentage =
//     allItems.length > 0
//       ? Math.round(
//           (completedItems /
//             allItems.length) *
//             100,
//         )
//       : 0;

//   const isCompleted =
//     percentage === 100;

//   return (
//     <div
//       className="rounded-xl overflow-hidden border"
//       style={{
//         borderLeft: `6px solid ${
//           isCompleted
//             ? "#16A34A"
//             : phaseData.color
//         }`,
//       }}
//     >
//       <button
//         onClick={onToggle}
//         className="w-full flex items-center justify-between px-5 py-4"
//         style={{
//           background:
//             phaseData.accent,
//         }}
//       >
//         <div className="flex items-center gap-3">
//           {isOpen ? (
//             <ChevronDown size={18} />
//           ) : (
//             <ChevronRight size={18} />
//           )}

//           <div className="text-left">
//             <h3 className="font-bold">
//               {phaseName}
//             </h3>

//             <p className="text-sm text-gray-600">
//               {completedItems} /{" "}
//               {allItems.length}
//               {" "}Completed
//             </p>
//           </div>
//         </div>

//         <span
//           className="px-3 py-1 rounded-full text-white text-xs"
//           style={{
//             background:
//               isCompleted
//                 ? "#16A34A"
//                 : phaseData.color,
//           }}
//         >
//           {percentage}%
//         </span>
//       </button>

//       {isOpen && (
//         <div className="bg-white">
//           {Object.entries(
//             phaseData.sections,
//           ).map(
//             (
//               [
//                 sectionTitle,
//                 sectionItems,
//               ],
//               sectionIndex,
//             ) => (
//               <div
//                 key={
//                   sectionTitle
//                 }
//                 className="border-t"
//               >
//                 <div className="px-5 py-4 bg-gray-50">
//                   <h4 className="font-semibold text-gray-800">
//                     {sectionTitle}
//                   </h4>
//                 </div>

//                 <div className="p-4 space-y-3">
//                   {sectionItems.map(
//                     (item) => (
//                       <ChecklistItemRow
//                         key={
//                           item.checklistCode
//                         }
//                         item={
//                           item
//                         }
//                         clientId={
//                           clientId
//                         }
//                         onUpdate={
//                           onChecklistUpdate
//                         }
//                       />
//                     ),
//                   )}
//                 </div>
//               </div>
//             ),
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default OnboardingPhaseAccordion;

import React from "react";

import {
  ChevronDown,
  ChevronRight,
  Building2,
  KeyRound,
  Globe,
  Megaphone,
  Palette,
  Rocket,
  BarChart3,
  Link2,
  Pencil,
  X,
} from "lucide-react";

import ChecklistItemRow from "./ChecklistItemRow";
import { formatDateTime } from "../../helpers/formatDateTime";
import { useState } from "react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { toast } from "react-toastify";

const phaseIcons = {
  "PHASE 01": Building2,
  "PHASE 02": KeyRound,
  "PHASE 03": Globe,
  "PHASE 04": Megaphone,
  "PHASE 05": Palette,
  "PHASE 06": Rocket,
  "PHASE 07": BarChart3,
};

const OnboardingPhaseAccordion = ({
  phaseName,
  applicableFor,
  phaseData,
  phaseAttachments,
  clientOnboardingDate,
  isOpen,
  onToggle,
  clientId,
  onChecklistUpdate,
  getOneClientOnboarding,
}) => {
  const Icon = phaseIcons[phaseName] || Building2;

  const allItems = Object.values(phaseData.sections).flat();

  const completedItems = allItems.filter((item) => item.received).length;

  const percentage =
    allItems.length > 0
      ? Math.round((completedItems / allItems.length) * 100)
      : 0;

  const phaseTitle = Object.keys(phaseData.sections)[0] || phaseName;

  const currentPhaseAttachment = phaseAttachments?.find(
    (item) => item.phase === phaseName
  );
  const [attachmentLink, setAttachmentLink] = useState( currentPhaseAttachment?.attachmentLink || "");

  const [savingAttachment, setSavingAttachment] = useState(false);
  
  const [editAttachment, setEditAttachment] = useState(!currentPhaseAttachment?.attachmentLink);
  
  const handleSaveAttachment = async () => {
    try {
      setSavingAttachment(true);

      await api({
        ...SummaryApi.OnboardingPhaseAttachment,

        data: {
          clientId,

          phase: phaseName,

          phaseCode:
            allItems?.[0]?.sectionCode,

          attachmentLink,
        },
      });

      toast.success(
        "Attachment updated successfully"
      );

      getOneClientOnboarding();
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to update attachment"
      );
    } finally {
      setSavingAttachment(false);
    }
  };

 return (
    <div className="mb-6">
      {/* Phase Header */}
      <div
        onClick={onToggle}
        className="
          cursor-pointer
          rounded-xl
          overflow-hidden
          border
          border-white/10
          bg-white
          px-6
          py-6
          shadow-lg
        "
      >
        <div className="flex items-center justify-between">
          {/* Left */}
          <div className="flex items-center gap-5">
            <div
              className="
                h-14 w-14
                rounded-2xl
                flex items-center justify-center
                bg-white/10
              "
            >
              <Icon size={30} color={phaseData.color} />
            </div>

            <div>
            <p
              className="uppercase tracking-[3px] text-sm font-bold"
              style={{
                color: phaseData.color,
              }}
            >
              {phaseName}
            </p>

            {applicableFor?.map((item) => (
              <span
                key={item}
                className="
                  text-xs
                  font-medium
                  text-blue-700
                  capitalize
                "
              >
                {item.replaceAll("_", " ")}
              </span>
            ))}

              <h2
                style={{
                  color: phaseData.accent,
                }}
                className={`text-lg md:text-2xl font-bold`}
              >
                {phaseTitle}
              </h2>
            </div>
          </div>

          {/* Right */}
          <div className="flex items-center gap-6">
            <div className="text-right">
              <h3
                className="text-xl md:text-3xl font-bold"
                style={{
                  color: phaseData.color,
                }}
              >
                {percentage}%
              </h3>

              <p className="text-gray-400 text-sm">
                {completedItems}/{allItems.length} done
              </p>
            </div>

            {isOpen ? (
              <ChevronDown size={28} color="#9CA3AF" />
            ) : (
              <ChevronRight size={28} color="#9CA3AF" />
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      {isOpen && (
        <div className="mt-3 bg-white rounded-2xl border shadow-sm overflow-hidden">
          {Object.entries(phaseData.sections).map(
            ([sectionTitle, sectionItems]) => {
              const completedSectionItems = sectionItems.filter(
                (x) => x.received,
              ).length;

              const sectionPercentage = sectionItems.length
                ? Math.round(
                    (completedSectionItems / sectionItems.length) * 100,
                  )
                : 0;
              const groupedSubsections = sectionItems.reduce((acc, item) => {
                const key = item.subsectionName || "General";

                if (!acc[key]) {
                  acc[key] = [];
                }

                acc[key].push(item);

                return acc;
              }, {});

              return (
                <div key={sectionTitle} className="p-5">
                  <div className="mb-5">
                    <div className="flex items-center justify-between">
                      <h3 className="text-lg font-bold text-gray-800">
                        {sectionTitle}
                      </h3>

                      <span
                        className="px-3 py-1 rounded-full text-xs font-semibold text-white"
                        style={{
                          backgroundColor: phaseData.color,
                        }}
                      >
                        {sectionPercentage}%
                      </span>
                    </div>

                    <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div
                        className="h-full rounded-full"
                        style={{
                          width: `${sectionPercentage}%`,
                          backgroundColor: phaseData.color,
                        }}
                      />
                    </div>
                    <div className="mt-5 border rounded-xl p-4 bg-gray-50">
                      <div className="flex items-center justify-between mb-3">
                        <h4 className="font-semibold">
                          {phaseName} Attachment
                        </h4>

                        {currentPhaseAttachment?.attachmentLink && (
                        <button
                          onClick={() => setEditAttachment(!editAttachment)}
                          className={`flex items-center gap-2 ${
                            editAttachment
                              ? "text-red-600 hover:text-red-700"
                              : "text-blue-600 hover:text-blue-700"
                          }`}
                        >
                          {editAttachment ? (
                            <>
                              <X size={16} />
                              Close
                            </>
                          ) : (
                            <>
                              <Pencil size={16} />
                              Edit
                            </>
                          )}
                        </button>
                        )}
                      </div>

                      {!currentPhaseAttachment?.attachmentLink ||
                      editAttachment ? (
                        <div className="flex flex-col md:flex-row gap-3">
                          <input
                            type="url"
                            value={attachmentLink}
                            onChange={(e) =>
                              setAttachmentLink(e.target.value)
                            }
                            placeholder="Paste attachment link"
                            className="
                              flex-1
                              border
                              rounded-lg
                              px-3
                              py-2
                            "
                          />

                          <button
                            onClick={async () => {
                              await handleSaveAttachment();

                              setEditAttachment(false);
                            }}
                            disabled={savingAttachment}
                            className="
                              bg-blue-600
                              text-white
                              px-4
                              py-2
                              rounded-lg
                            "
                          >
                            {savingAttachment
                              ? "Saving..."
                              : "Save"}
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center justify-between">
                          <a
                            href={
                              currentPhaseAttachment.attachmentLink
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="
                              flex items-center gap-2
                              text-blue-600
                              hover:underline
                            "
                          >
                            <Link2 size={16} />
                            View Attachment
                          </a>
                        </div>
                      )}

                      <div className="mt-4">
                        <p className="text-xs text-gray-500">
                          Client Onboarding Date
                        </p>

                        <p className="text-sm font-medium">
                          {clientOnboardingDate
                            ? formatDateTime(
                                clientOnboardingDate,
                                false
                              )
                            : "Not Scheduled"}
                        </p>
                      </div>
                    </div>
                  </div>

                  {Object.entries(groupedSubsections).map(
                    ([subsectionName, subsectionItems]) => {
                      const completedSubItems = subsectionItems.filter(
                        (x) => x.received,
                      ).length;

                      const subPercentage = subsectionItems.length
                        ? Math.round(
                            (completedSubItems / subsectionItems.length) * 100,
                          )
                        : 0;

                      return (
                        <div key={subsectionName} className="mb-5">
                          {subsectionName !== "General" && (
                            <div className="bg-gray-50 border rounded-xl p-4 mb-4">
                              <div className="flex items-center justify-between">
                                <h4 className="font-semibold text-gray-800">
                                  {subsectionName}
                                </h4>

                                <span className="text-sm font-medium text-gray-600">
                                  {completedSubItems}/{subsectionItems.length}{" "}
                                  Done
                                </span>
                              </div>

                              <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden">
                                <div
                                  className="h-full rounded-full"
                                  style={{
                                    width: `${subPercentage}%`,
                                    backgroundColor: phaseData.color,
                                  }}
                                />
                              </div>
                            </div>
                          )}

                          <div className="space-y-3">
                            {subsectionItems.map((item) => (
                              <ChecklistItemRow
                                key={item.checklistCode}
                                item={item}
                                clientId={clientId}
                                onUpdate={onChecklistUpdate}
                              />
                            ))}
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              );
            },
          )}
        </div>
      )}
    </div>
  );
};

export default OnboardingPhaseAccordion;
